export default "__VITE_ASSET__DcxmjxG8__"